export default {"src":"/_next/static/media/aws-icon.09f18f96.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};